var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 412.03 126.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill-rule: evenodd;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "266.27 50.66 275.16 39.69 292.89 17.94 276.08 17.94 259.87 39.69 254.2 47.31 254.2 39.69 254.2 17.94 240.37 17.94 240.37 39.69 240.37 53.64 240.37 88.31 254.2 88.31 254.2 56.99 276.81 88.31 294.78 88.31 268.52 53.64 266.27 50.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m149.1,17.94h-19.25v70.37h19.25c33.02.12,34.42-30.34,34.49-34.73v-.43c0-.85,0-6.7-2.25-13.46-3.35-9.93-11.64-21.75-32.23-21.75Zm20.17,35.76c-.3,26.2-25.35,22.66-25.35,22.66V30s15.48-2.19,22.24,9.63c1.89,3.29,3.11,7.68,3.11,13.53v.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m388.05,24.37c-4.12-10.9-11.4-10.57-15.5,0-4.2,10.83-22.1,58.3-24.04,63.47l-19.49-28.9s5-.97,9.08-5.24c2.68-2.92,5-7.31,5-14.01v-.06s1.71-21.69-22.6-21.69h-19.31v70.37h13.83v-28.27l17.24,28.27h29.89l5.33-14.77h24.7l5.81,14.77h14.05s-19.86-53.04-23.98-63.93Zm-69.75,25.86h-3.29v-21.02h3.29c11.88-.06,11.39,10.3,11.39,10.3v.18c0,1.34-.66,10.54-11.39,10.54Zm53.04,11.92l8.96-25.43,8.72,25.43h-17.68Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "192.18 39.69 192.12 53.64 192.12 88.31 228.43 88.31 228.43 76.37 206.01 76.37 206.01 57.36 227.7 57.36 227.7 53.64 227.7 45.36 206.01 45.36 206.01 39.69 206.01 30 228.49 30 228.49 18 192.18 18 192.18 39.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m79.11,33.41C64.93,24.96,28.09,3.7,23.57,1.11c-4.52-2.58-8.4-.65-8.4,5.49v63.29l17.76-9.69V27.27l38.75,22.93L0,92.5v20.67s65.23-37.78,79.11-45.53c13.89-7.75,15.18-25.19,0-34.23Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m241.84,107.51v18.21h-2.26v-18.21h-4.94v-2.13h12.14v2.13h-4.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m262.67,107.51h-8.3v6.04h8.05v2.14h-8.05v7.9h8.3v2.13h-10.55v-20.34h10.55v2.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m278.19,109.4c-.27-.55-.73-1.16-1.19-1.53-.4-.3-1.13-.7-2.29-.7-2.01,0-3.42,1.25-3.42,3.14,0,.79.21,1.25.76,1.77.61.61,1.37.95,2.14,1.28l1.95.85c1.19.52,2.29,1.07,3.14,1.92,1.04,1.04,1.46,2.23,1.46,3.69,0,3.75-2.78,6.25-6.44,6.25-1.34,0-3.02-.27-4.42-1.65-1.01-.98-1.62-2.38-1.89-3.6l2.2-.61c.15,1.07.64,1.98,1.22,2.59.88.88,1.89,1.13,2.93,1.13,2.78,0,4.09-1.98,4.09-4.03,0-.92-.27-1.71-1.01-2.38-.58-.55-1.37-.92-2.44-1.4l-1.83-.85c-.79-.37-1.8-.79-2.71-1.68-.88-.85-1.4-1.8-1.4-3.33,0-3.14,2.41-5.25,5.7-5.25,1.25,0,2.26.24,3.26.92.82.55,1.53,1.37,1.98,2.26l-1.8,1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m290.91,107.51v18.21h-2.26v-18.21h-4.94v-2.13h12.14v2.13h-4.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m314.23,105.37c1.13,0,3.17.09,4.67,1.28.64.49,1.83,1.74,1.83,4.21,0,1.01-.21,2.78-2.01,4,2.84.7,3.87,3.17,3.87,5.12s-.98,3.54-2.07,4.39c-1.62,1.28-3.48,1.34-4.88,1.34h-5.06v-20.34h3.66Zm-1.4,8.94h1.71c1.19,0,4-.24,4-3.39,0-3.35-3.29-3.42-3.93-3.42h-1.77v6.8Zm0,9.27h2.59c1.31,0,2.59-.09,3.57-.85.79-.58,1.34-1.59,1.34-2.81,0-1.62-.95-2.56-1.74-2.99-.76-.43-1.83-.61-3.45-.61h-2.32v7.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m340.25,119.98h-8.66l-2.44,5.73h-2.5l9.36-21.32,9.12,21.32h-2.5l-2.38-5.73Zm-.88-2.13l-3.42-8.14-3.48,8.14h6.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m353.91,107.51v18.21h-2.26v-18.21h-4.94v-2.13h12.14v2.13h-4.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m374.74,107.51h-8.3v6.04h8.05v2.14h-8.05v7.9h8.3v2.13h-10.55v-20.34h10.55v2.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m384.44,105.37c1.37,0,3.42.09,4.94,1.13,1.19.79,2.23,2.35,2.23,4.51,0,3.11-2.04,5.4-5.12,5.61l6.47,9.09h-2.75l-6.19-8.91h-.58v8.91h-2.26v-20.34h3.26Zm-1.01,9.42h1.43c2.81,0,4.48-1.34,4.48-3.72,0-1.13-.34-2.26-1.62-2.99-.92-.52-1.95-.58-2.93-.58h-1.37v7.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m401.03,105.37v20.34h-2.26v-20.34h2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m410.81,105.37v20.34h-2.26v-20.34h2.26Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHeader);
export default __webpack_public_path__ + "static/media/logo-header.726018ab9ee767362d6f25b9a675a42c.svg";
export { ForwardRef as ReactComponent };